<p-toast position="top-center" [baseZIndex]="20000" />
<router-outlet />
